import { addCerrar, ponerCaptchaModal, createLoader, iniciarForms } from '../js/utils.js'

export function crearModals($modals, optionsOpenStart = null, optionsOpenEnd = null){

	if(optionsOpenStart === null){
		optionsOpenStart = crearModalsDefaultOpenStart()
	}

	if(optionsOpenEnd === null){
		optionsOpenEnd = crearModalsDefaultOpenEnd()
	}

	$modals.modal({
		dismissible: false,
		onOpenStart: optionsOpenStart,
		onOpenEnd: optionsOpenEnd,
	});
}

function crearModalsDefaultOpenStart(modal, trigger){
	return function (modal, trigger) {
		var $modal		= $(modal)
		addCerrar(modal);
		ponerCaptchaModal($modal)
		if(trigger != undefined){
			crearModalsDataHidden($modal, $(trigger))
		}
	};
}

function crearModalsDefaultOpenEnd(modal, trigger){
	return function (modal, trigger) {
		var $modal		= $(modal)
		if($modal.find('form').length != 0){
			iniciarForms($modal.find('form'))
		}
	};
}

export function crearModalsDataHidden($modal, $trigger){
	let data 	= $trigger.data()
	for(let i in data){
		$modal.find('[name="' + i + '"]').val(data[i])
	}
}

export function mandatoryModals(){
	let $mandatory = $('.mandatory').first()
	if($mandatory.length == 0) return ;

	$('body').css('overflow', 'hide')

	$mandatory.css('z-index', 9999);
	var instances = M.Modal.init($mandatory.get(0), {dismissible: false, opacity: .8});
	instances.open();
}

/** Crea un modal descargandolo de la nube */
export function crearGenModal(trigger, id, name = null, option = {}, optionsOpenStart = null, optionsOpenEnd = null, dismissible = false, autoOpen = true){
	$('#' + id).remove()
	name 				= name === null ? id : name
	option['dataset']	= $(trigger).data()
	$.ajax({
			url:        '/modals/' + name + '/'
		,   type:       'POST'
		,   data:       option
		,   dataType:   "html"
		,	beforeSend: function(){
				createLoader(true)
		}
		,   success: function(data) {  
				$('body').append(data)

				let $genModal = $('#' + id)
				crearModalsDataHidden($genModal, $(trigger))
				crearModals($genModal, optionsOpenStart, optionsOpenEnd)
				if(autoOpen){
					let instances = M.Modal.getInstance($genModal.get(0));
					instances.open();
				}

				createLoader(false);
				if(typeof callBack == 'function') callBack(data);
			}
		,   error: function (data, status, e){
				console.log("jSONInfo - No se pudo cargar la pagina: ",data.responseText);
			}
		});	
}



// WEBPACK FOOTER //
// ./src/js/modals.js